module.exports = __webpack_public_path__ + "static/media/grand_mum_talking_02.21c12568.png";